import React from 'react';
import { Button } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';

export default function AddRouteButton({ onClick, edit }) {
  const handleClick = (e) => {
    e.preventDefault();
    onClick();
  };

  return (
    <Button
      variant='outlined'
      startIcon={<AddIcon />}
      onClick={handleClick}
      disabled={edit}
      sx={{ mt: 2 }}
    >
      Add Route
    </Button>
  );
}

